import React, { useEffect, useState } from "react";
import {
  Avatar,
  ChartsSetWrapperNew,
  Paragraph,
} from "../../../../../components";
import { getChartAdvMetricsLocal } from "./data";

const TableListAdv = () => {
  const todayIso = new Date().toISOString().slice(0, 10);

  const [categories, setCategories] = useState([]);
  const [series, setSeries] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    from: null,
    to: null,
  });

  function onchange({ from, to }) {
    setSelectedDate({ from, to });
    const { categories, series } = getChartAdvMetricsLocal({ from, to });
    setCategories(categories);
    setSeries(series);
  }

  return (
    <div>
      <Paragraph className="p-2 text-xs" lines={1}>
        The table chart displays data in a tabular format, with each row
        representing a category and each column representing a series. The chart
        allows users to filter the data by date range and series, and to toggle
        between stacked and non-stacked views.
      </Paragraph>
      {/* <ChartsSetWrapperNew
        title="Line"
        type="line"
        data={series}
        categories={categories}
        options={{
          dateConfig: {
            dateFilter: true,
            dateRange: selectedDate,
            onChange: onchange,
          },
        }}
      /> */}
      <ChartsSetWrapperNew
        title="All"
        type="table"
        data={series}
        categories={categories}
        options={{
          dateConfig: {
            dateFilter: true,
            dateRange: selectedDate,
            onChange: onchange,
            defaultOption: "last week",
          },
          seriesFilter: {
            showFilter: true,
            title: "Employees",
            searchPlaceholder: "Filter Employees",
          },
          toggleChart: {
            showToggle: true,
          },
          column: {
            stacked: true,
          },
          bar: {
            stacked: true,
          },
        }}
        // options={{
        //   table: {
        //     columns: [
        //       {
        //         key: "group",
        //         label: "Group",
        //         dataType: "string",
        //         render: (row) => (
        //           <div className="flex items-center gap-1.5">
        //             <Avatar alt={row.group} size="xs" /> {row.group}
        //             {row.seriesId != null && row.seriesId !== "" ? (
        //               <span className="text-xs text-gray-500">
        //                 ({row.seriesId})
        //               </span>
        //             ) : null}
        //           </div>
        //         ),
        //       },
        //       {
        //         key: "category",
        //         label: "Duration",

        //         dataType: "string",
        //         render: (row) => <div>{row.category}</div>,
        //       },
        //     ],
        //   },
        // }}
      />
    </div>
  );
};

export default TableListAdv;
